
/* eslint no-underscore-dangle:  0 */
/* eslint-disable no-debugger, no-console */
/* eslint-disable */
import { GET_ALL_TRANSACTION_FAILURE } from "Redux/types/transaction"
import { GET_ALL_TRANSACTION_SUCCESS } from "Redux/types/transaction"
import { GET_ALL_TRANSACTION_REQUEST } from "Redux/types/transaction"
import axios from "axios"
import { apiVersionPrefix } from "config"
import { apiBaseUrl } from "config"
import { getCookie } from "cookie/cookie"

const { CREATE_TRANSACTION_FAILURE } = require("Redux/types/transaction")
const { GET_TRANSACTION_SUCCESS } = require("Redux/types/transaction")
const { UPDATE_TRANSACTION_REQUEST } = require("Redux/types/transaction")
const { UPDATE_TRANSACTION_FAILURE } = require("Redux/types/transaction")
const { DELETE_TRANSACTION_SUCCESS } = require("Redux/types/transaction")
const { DELETE_TRANSACTION_FAILURE } = require("Redux/types/transaction")
const { DELETE_TRANSACTION_REQUEST } = require("Redux/types/transaction")
const { UPDATE_TRANSACTION_SUCCESS } = require("Redux/types/transaction")
const { GET_TRANSACTION_FAILURE } = require("Redux/types/transaction")
const { GET_TRANSACTION_REQUEST } = require("Redux/types/transaction")
const { CREATE_TRANSACTION_SUCCESS } = require("Redux/types/transaction")
const { CREATE_TRANSACTION_REQUEST } = require("Redux/types/transaction")

//create transation action
export const createTransaction = (transaction) => async (dispatch) => {
    try {
        dispatch({ type: CREATE_TRANSACTION_REQUEST });
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${getCookie('token')}`
            },
        };
        const { data } = await axios.post(`${apiBaseUrl}${apiVersionPrefix}/transaction/create`, transaction, config);
        dispatch({ type: CREATE_TRANSACTION_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: CREATE_TRANSACTION_FAILURE,
            payload: error.response && error.response.data.message ? error.response.data.message : error.message,
        });
    }
}
//get all transation action
export const getAllTransaction = () => async (dispatch) => {
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${getCookie('token')}`
            },
        };
        dispatch({ type: GET_ALL_TRANSACTION_REQUEST });
        const { data } = await axios.get(`${apiBaseUrl}${apiVersionPrefix}/transaction/all`,config);
        dispatch({ type: GET_ALL_TRANSACTION_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: GET_ALL_TRANSACTION_FAILURE,
            payload: error.response && error.response.data.message ? error.response.data.message : error.message,
        });
    }
}
//get single transation action
export const getTransaction = (id) => async (dispatch) => {
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${getCookie('token')}`
            },
        };
        dispatch({ type: GET_TRANSACTION_REQUEST });
        const { data } = await axios.get(`${apiBaseUrl}${apiVersionPrefix}/transaction/get-transaction/${id}`,config);
        dispatch({ type: GET_TRANSACTION_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: GET_TRANSACTION_FAILURE,
            payload: error.response && error.response.data.message ? error.response.data.message : error.message,
        });
    }
}
//update transation action
export const updateTransaction = ( transaction) => async (dispatch) => {
    try{
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${getCookie('token')}`
            },
        };
        dispatch({ type: UPDATE_TRANSACTION_REQUEST });
        const { data } = await axios.put(`${apiBaseUrl}${apiVersionPrefix}/transaction/update-transaction/${transaction.id}`,transaction,config);
        dispatch({ type: UPDATE_TRANSACTION_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: UPDATE_TRANSACTION_FAILURE,
            payload: error.response && error.response.data.message ? error.response.data.message : error.message,
        });
    }
    }
    export const deleteTransaction = (id) => async (dispatch) => {
        try{
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${getCookie('token')}`
                },
            };
            dispatch({ type: DELETE_TRANSACTION_REQUEST });
            const { data } = await axios.delete(`${apiBaseUrl}${apiVersionPrefix}/transaction/delete-transaction/${id}`,config);
            dispatch({ type: DELETE_TRANSACTION_SUCCESS, payload: data });
        } catch (error) {
            dispatch({
                type: DELETE_TRANSACTION_FAILURE,
                payload: error.response && error.response.data.message ? error.response.data.message : error.message,
            });
        }
        }

